import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProduitService } from '../../services/produit.service';
import { CandidatureForm } from '../../models/personne.model';
import { Forfait, InstanceEtProduit } from '../../models/produit.model';

import { FileUploadService } from '../../services/fileUpload.service';

declare let gtag: Function;

class ImageSnippet {
  constructor(public src: string, public file: File) {}
}

@Component({
  selector: 'app-candidature',
  templateUrl: './candidature.component.html',
  styleUrls: ['./candidature.component.scss']
})
export class CandidatureComponent implements OnInit {
  url_instance: string;
  instance: InstanceEtProduit;
  forfait: Forfait;
  candidatureForm = new CandidatureForm();
  choixSpe = new Array<string>();
  selectedChoices = new Array<string>();
  bachelier: string;
  futur_bachelier: string;
  error = '';
  isSent = false;

  selectedFile: ImageSnippet;
  file_name = '';

  constructor(
    private fileUploadService: FileUploadService,
    private produitService: ProduitService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.instance = this.route.snapshot.data.instanceEtProduit;
    this.candidatureForm.id_instance = this.instance.id_instance;
    if (this.instance.choix_specifiques) {
      this.choixSpe = this.instance.choix_specifiques.split(';');
    }
  }

  ngOnInit(): void {
    this.initBachelier();
    this.initChoixSpe();
    if (this.instance.id_forfait) {
      this.getForfait(this.instance.id_forfait);
    }
    if (this.instance.couleur_background && isPlatformBrowser(this.platformId)) {
      document.getElementById('instance-content').style.backgroundColor = this.instance.couleur_background;
      document.getElementById('footer').style.backgroundColor = this.instance.couleur_background;
    }
  }

  ngOnDestroy() {
    if (this.instance.couleur_background && isPlatformBrowser(this.platformId)) {
      if (document.getElementById('instance-content')) {
          document.getElementById('instance-content').style.backgroundColor = '#fafafd';
      }
      if (document.getElementById('footer')) {
          document.getElementById('footer').style.backgroundColor = '#fafafd';
      }
    }
  }

  initBachelier() {
    const date = new Date();
    const currentMonth = date.getMonth() + 1;
    const currentYear = date.getFullYear();
    if (currentMonth < 7) {
      this.bachelier = 'Bachelier ' + (currentYear - 2) + '-' + (currentYear - 1);
      this.futur_bachelier = 'Futur bachelier ' + (currentYear - 1) + '-' + currentYear;
    } else {
      this.bachelier = 'Bachelier ' + (currentYear - 1) + '-' + currentYear;
      this.futur_bachelier = 'Futur bachelier ' + currentYear + '-' + (currentYear + 1);
    }
  }

  initChoixSpe() {
    if (this.choixSpe) {
      this.choixSpe.forEach(choice => {
        this.selectedChoices.push(choice);
      });
      this.updateChoixSpe();
    }
  }

  onChoixClick(event): void {
    const target = event.target;
    const value = target.value;
    const checked = target.checked;
    if (checked) {
      if (value && value !== '') {
        this.selectedChoices.push(value);
      }
    } else {
      const index = this.selectedChoices.indexOf(value);
      if (index > -1) {
        this.selectedChoices.splice(index, 1);
      }
    }
    this.updateChoixSpe();
  }

  getForfait(id_forfait): void {
    this.produitService.getForfait(id_forfait.toString()).subscribe(
      (res: Forfait) => {
        this.forfait = res;
        if (this.forfait?.couleurs) {
          this.initColors();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  initColors() {
    if (this.forfait && this.forfait.couleurs) {
        this.setColors('.entete', this.forfait.couleurs.couleur_fond_entete, this.forfait.couleurs.couleur_texte_entete);
        this.setColors('.entete-reverse', this.forfait.couleurs.couleur_texte_entete, this.forfait.couleurs.couleur_fond_entete);
        this.setColors('.ligne', this.forfait.couleurs.couleur_fond_ligne, this.forfait.couleurs.couleur_texte_ligne);
        this.setColors('.text-color', 'transparent', this.forfait.couleurs.couleur_fond_entete);
    } else {
        // default colors
        this.setColors('.entete', '#4F71BE', '#ffffff');
        this.setColors('.entete-reverse', '#ffffff', '#4F71BE');
        this.setColors('.ligne', '#CED3E7', '#000000');
        this.setColors('.text-color', 'transparent', '#4F71BE');
    }
  }

  setColors(ClassName, backgroundColor, textColor) {
    if (isPlatformBrowser(this.platformId)) {
      const elements = document.querySelectorAll(ClassName);
      const array = Array.from(elements);
      array.forEach(element => element.style.backgroundColor = backgroundColor);
      array.forEach(element => element.style.color = textColor);
    }
  }

  updateChoixSpe() {
    this.candidatureForm.choix_speficiques = this.selectedChoices.join(';');
  }

  verifNom(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const value = target.value;
    if ((value.length < 1) || (value.length > 20)) {
        this.surligne(target, true);
        return false;
    } else {
        this.surligne(target, false);
        return true;
    }
  }

  verifAdresse(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const value = target.value;
    if ((value.length < 1) || (value.length > 40)) {
      this.surligne(target, true);
      return false;
    } else {
      this.surligne(target, false);
      return true;
    }
  }

  verifMail(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const value = target.value;
    const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
    if (!regex.test(value)) {
      this.surligne(target, true);
      return false;
    } else {
      if ((value.length < 1) || (value.length > 40)) {
        this.surligne(target, true);
        return false;
      } else {
        this.surligne(target, false);
        return true;
      }
    }
  }

  verifTel(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const value = target.value;
    const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
    if (!regex.test(value)) {
      this.surligne(target, true);
      return false;
    } else {
      if ((value.length < 10) || (value.length > 15)) {
        this.surligne(target, true);
        return false;
      } else {
        this.surligne(target, false);
        return true;
      }
    }
  }

  surligne(target, erreur) {
    if (isPlatformBrowser(this.platformId)) {
      const idAttr = target.attributes.id;
      const idValue = idAttr.nodeValue;
      if (erreur) {
        document.getElementById(idValue).style.backgroundColor = '#fba';
      } else {
        document.getElementById(idValue).style.backgroundColor = '';
      }
    }
  }

  onFileChangedEdition(event) {
    const file: File = event.target.files[0];
    const reader = new FileReader();
    // tslint:disable-next-line: no-shadowed-variable
    reader.addEventListener('load', (event: any) => {
      this.selectedFile = new ImageSnippet(event.target.result, file);
      this.fileUploadService.uploadCV(this.selectedFile.file).subscribe(
        (res) => {
          console.log('file well uploaded');
          this.candidatureForm.cv = file.name;
          this.file_name = file.name;
        },
        (err) => {
          console.log('file not uploaded : ' + err );
        }
      );
    });
    reader.readAsDataURL(file);
  }

  submit() {
    this.error = '';
    if (this.instance.question_specifique &&
      (!this.candidatureForm.choix_speficiques || this.candidatureForm.choix_speficiques === '')) {
      this.error = 'Veuillez faire au moins un choix dans la section BTS svp.';
      return;
    }
    if (!this.candidatureForm.cours_presentiels_uniquement && this.candidatureForm.cours_presentiels_uniquement !== false) {
      this.error = 'Veuillez faire un choix dans la section COURS svp.';
      return;
    }
    if (!this.candidatureForm.recherche_entreprise && this.candidatureForm.recherche_entreprise !== false) {
      this.error = 'Veuillez faire un choix dans la section ENTREPRISE svp.';
      return;
    }
    if (!this.candidatureForm.nom || this.candidatureForm.nom === '') {
      this.error = 'Veuillez entrer votre nom svp.';
      return;
    }
    if (!this.candidatureForm.prenom || this.candidatureForm.prenom === '') {
      this.error = 'Veuillez entrer votre prénom svp.';
      return;
    }
    if (!this.candidatureForm.email || this.candidatureForm.email === '') {
      this.error = 'Veuillez entrer votre adresse email svp.';
      return;
    } else {
      const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
      if (!regex.test(this.candidatureForm.email)) {
        this.error = 'Veuillez entrer une adresse mail valide svp.';
        return;
      }
    }
    if (!this.candidatureForm.telephone || this.candidatureForm.telephone === '') {
      this.error = 'Veuillez entrer votre numéro de téléphone svp.';
      return;
    } else {
      const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
      if (!regex.test(this.candidatureForm.telephone)) {
        this.error = 'Veuillez entrer un numéro de téléphone valide svp.';
        return;
      }
    }
    if (!this.candidatureForm.birthday) {
      this.error = 'Veuillez indiquer votre date de naissance svp.';
      return;
    }
    if (!this.candidatureForm.annee_bac || this.candidatureForm.annee_bac === '') {
      this.error = 'Veuillez préciser si vous êtes bachelier via le champ "Je suis..." svp.';
      return;
    }
    if (!this.candidatureForm.cv || this.candidatureForm.cv === '') {
      this.error = 'Veuillez ajouter votre CV svp.';
      return;
    }

    // If we didn't get any error, then we send the form
    this.sendForm();
  }

  sendForm(): void {
    this.produitService.sendCandidatureForm(this.candidatureForm).subscribe(
      (res: any) => {
        this.isSent = true;

        if (isPlatformBrowser(this.platformId)) {
          // Event snippet for Envoi de formulaire pour prospects conversion page -->
          gtag('event', 'conversion', {'send_to': 'AW-456060824/lUTqCOeglZMCEJjfu9kB'});
        }
      },
      (err) => {
        this.error = 'Une erreur est survenue lors de l\'envoi du formulaire. Veuillez vérifier les informations saisies svp.\n Si toutefois l\'erreur persiste, veuillez nous contacter svp.';
        console.log(err);
      }
    );
  }
}
